import { Box, Container, Divider, SimpleGrid } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import Header from './Header';
import LearnMoreButton from './LearnMoreButton';
import CollapseItem from '../../common/collapse-item';

const Desktop: React.FC = () => {
  const [showTopCollapse, setShowTopCollapse] = useState<boolean>(true);
  const [showBottomCollapse, setShowBottomCollapse] = useState<boolean>(false);

  const onClickFirst = () => {
    if (showTopCollapse) {
      setShowTopCollapse(!showTopCollapse);
      setTimeout(() => {
        setShowBottomCollapse(!showBottomCollapse);
      }, 300);
    } else {
      setShowBottomCollapse(!showBottomCollapse);
      setTimeout(() => {
        setShowTopCollapse(!showTopCollapse);
      }, 300);
    }
  };

  const onClickSecond = () => {
    if (showBottomCollapse) {
      setShowBottomCollapse(!showBottomCollapse);
      setTimeout(() => {
        setShowTopCollapse(!showTopCollapse);
      }, 300);
    } else {
      setShowTopCollapse(!showTopCollapse);
      setTimeout(() => {
        setShowBottomCollapse(!showBottomCollapse);
      }, 300);
    }
  };

  return (
    <SimpleGrid
      d={{ base: 'none', desktop: 'grid' }}
      columns={2}
      alignItems="center"
      spacing="83px"
      h="560px"
    >
      <Container maxW="xl">
        <Box d={showTopCollapse ? 'flex' : 'none'}>
          <StaticImage
            placeholder="blurred"
            alt="easy imports"
            src="../../../assets/images/insurance_easy_import.png"
          />
        </Box>
        <Box d={!showTopCollapse ? 'flex' : 'none'}>
          <StaticImage
            placeholder="blurred"
            alt="real time 3d"
            src="../../../assets/images/insurance_fast_estimation.png"
          />
        </Box>
      </Container>
      <Container maxW="xl" h="100%">
        <Header mb={{ base: 600, tablet: 800 }} />
        <Box flexDir="column">
          <CollapseItem
            onClick={onClickFirst}
            isActive={showTopCollapse}
            content="Import 3D model data and accurate measurements directly into your claims
           management tool of choice. No manual sketching required."
            title="Easy imports"
          />
          <CollapseItem
            onClick={onClickSecond}
            isActive={showBottomCollapse}
            content="Better measurements means more accurate estimations.
           Minimize errors and settle property claims quickly and more accurately."
            title="Better estimates"
            body="Pass your property measurements right into Xactimate or connect directly
             with Symbility or Filetrac."
          />
        </Box>
        <Divider color="neutral.300" mt={showBottomCollapse ? 0 : 500} my={0} />
        <LearnMoreButton />
      </Container>
    </SimpleGrid>
  );
};

export default Desktop;
